import { render, staticRenderFns } from "./InspectionPointDetail.vue?vue&type=template&id=2dabd4f7&scoped=true"
import script from "./InspectionPointDetail.vue?vue&type=script&lang=js"
export * from "./InspectionPointDetail.vue?vue&type=script&lang=js"
import style0 from "./InspectionPointDetail.vue?vue&type=style&index=0&id=2dabd4f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dabd4f7",
  null
  
)

export default component.exports